export const BURGER_MENU_EXPERIMENT_ID = "exp-burger-menu";
export const HIDE_BURGER_MENU_EXPERIMENT_VARIANT = "hide-burger-menu";
